export default [
    {
        path: 'classifiers/text_classifiers/new',
        name: 'create-text-classifier',
        component: () => import('pages/convolve/classifiers/train'),
    },
    {
        path: 'classifiers/text_classifiers',
        name: 'list-text-classifiers',
        component: () => import('pages/convolve/classifiers/list'),
    },
    {
        path: 'classifiers/text_classifier/:classifierId/train',
        name: 'train-text-classifier',
        component: () => import('pages/convolve/classifiers/train'),
    },
    {
        path: 'classifiers/text_classifier/:classifierId',
        name: 'edit-text-classifier',
        component: () => import('pages/convolve/classifiers/edit'),
    },
    {
        path: 'training_sets',
        name: 'list-training-sets',
        component: () => import('pages/convolve/training_sets/list'),
    },
    {
        path: 'training_sets/new',
        name: 'create-training-set',
        component: () => import('pages/convolve/training_sets/create'),
    },
    {
        path: 'label_set/:labelSetId/enhance',
        name: 'enhance-label-set',
        component: () => import('pages/convolve/label_sets/enhance'),
    },
    {
        path: 'label_set/:labelSetId',
        name: 'list-label-set-table',
        component: () => import('pages/convolve/label_sets/table'),
    },
    {
        path: 'classifiers/text_classifier/:classifierId/evaluate',
        name: 'evaluate-text-classifier',
        component: () => import('pages/convolve/classifiers/evaluate'),
    },
];
